<template>
  <section class="practice">
    <vue-snotify></vue-snotify>
    <div class="row">
      <aside class="col-md-3 col-sm-12 cus-sidebar">
        <practiceSidebar />
      </aside>
      <div v-if="isLoading" class="loader">
        <div class="wave-container">
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
        </div>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" id="content" class="content col-md-9 col-sm-12">
        <div class="material-box bg-white">
          <div class="col-md-12 top-title">
            <h3>Billing Information</h3>
          </div>
          <div class="col-md-12">
            <div class="section-container section-with-top-border p-b-10">
              <form
                class="form-horizontal fv-form fv-form-bootstrap"
                @submit.prevent="saveUser"
                method="post"
                enctype="multipart/form-data"
              >
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="PracticeName">Practice Name:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-user"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="PracticeName"
                          name="PracticeName"
                          autocomplete="PracticeName"
                          placeholder="First Name"
                          v-model="BillingInfo.PracticeName"
                          :state="
                            !$v.BillingInfo.PracticeName.$dirty
                              ? null
                              : !$v.BillingInfo.PracticeName.required ||
                                $v.BillingInfo.PracticeName.$error
                              ? false
                              : null
                          "
                          aria-describedby="input-1-live-feedback"
                          label="First Name"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="FirstName">First Name</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-user"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="FirstName"
                          name="FirstName"
                          autocomplete="FirstName"
                          placeholder="First Name"
                          v-model="BillingInfo.FirstName"
                          :state="
                            !$v.BillingInfo.FirstName.$dirty
                              ? null
                              : !$v.BillingInfo.FirstName.required ||
                                $v.BillingInfo.FirstName.$error
                              ? false
                              : null
                          "
                          ar
                          aria-describedby="input-1-live-feedback"
                          label="First Name"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="LastName">Last Name:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-user"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="LastName"
                          name="LastName"
                          autocomplete="LastName"
                          placeholder="Last Name"
                          v-model="BillingInfo.LastName"
                          :state="
                            !$v.BillingInfo.LastName.$dirty
                              ? null
                              : !$v.BillingInfo.LastName.required ||
                                $v.BillingInfo.LastName.$error
                              ? false
                              : null
                          "

                          aria-describedby="input-1-live-feedback"
                          label="Last Name"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="Address1">Address</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-globe"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          v-model="BillingInfo.Address1"
                          id="Address1"
                          :state="
                            !$v.BillingInfo.Address1.$dirty
                              ? null
                              : !$v.BillingInfo.Address1.required ||
                                $v.BillingInfo.Address1.$error
                              ? false
                              : null
                          "

                          name="Address1"
                          autocomplete="Address1"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <b-input-group>
                        <b-form-input
                          type="text"
                          id="Address2"
                          name="Address2"
                          autocomplete="Address2"
                          v-model="BillingInfo.Address2"
                        ></b-form-input>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="City">City:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-globe"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="City"
                          name="City"
                          autocomplete="City"
                          :state="
                            !$v.BillingInfo.City.$dirty
                              ? null
                              : !$v.BillingInfo.City.required ||
                                $v.BillingInfo.City.$error
                              ? false
                              : null
                          "
                          v-model="BillingInfo.City"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="StateID">State:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-globe"></i>
                        </b-input-group-prepend>
                        <b-form-select
                          id="StateID"
                          v-model="BillingInfo.StateID"
                          :state="
                            !$v.BillingInfo.StateID.$dirty
                              ? null
                              : !$v.BillingInfo.StateID.required ||
                                $v.BillingInfo.StateID.$error
                              ? false
                              : null
                          "
                          :options="StateOptions"
                          value-field="StateID"
                          text-field="Name"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="ZipCode">Zip:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-globe"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="ZipCode"
                          name="ZipCode"
                          :state="
                            !$v.BillingInfo.ZipCode.$dirty
                              ? null
                              : !$v.BillingInfo.ZipCode.required ||
                                $v.BillingInfo.ZipCode.$error
                              ? false
                              : null
                          "
                          autocomplete="ZipCode"
                          v-model="BillingInfo.ZipCode"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="Phone">Phone:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-globe"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="Phone"
                          :state="
                            !$v.BillingInfo.Phone.$dirty
                              ? null
                              : !$v.BillingInfo.Phone.required ||
                                $v.BillingInfo.Phone.$error
                              ? false
                              : null
                          "
                          name="Phone"
                          autocomplete="Phone"
                          v-model="BillingInfo.Phone"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="CardNumber">Credit Card Number:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-credit-card"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="CardNumber"
                          name="CardNumber"
                          :state="
                            !$v.BillingInfo.CardNumber.$dirty
                              ? null
                              : !$v.BillingInfo.CardNumber.required ||
                                $v.BillingInfo.CardNumber.$error
                              ? false
                              : null
                          "
                          autocomplete="CardNumber"
                          v-model="BillingInfo.CardNumber"
                          @input="onInputCreditCard"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div v-if="showCheckbox" class="form-group">
                      <b-form-checkbox
                        v-model="removeCreditCard"
                        @change="removeCreditCardHandler"
                        ><span class="text-danger" style="font-weight: bold"
                          >Remove Credit Card</span
                        ></b-form-checkbox
                      >
                    </div>
                    <div class="form-group">
                      <label for="Fax">Expiration Date:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-credit-card"></i>
                        </b-input-group-prepend>
                        <b-form-select
                          id="CardMonth"
                          :state="
                            !$v.BillingInfo.CardMonth.$dirty
                              ? null
                              : !$v.BillingInfo.CardMonth.required ||
                                $v.BillingInfo.CardMonth.$error
                              ? false
                              : null
                          "
                          v-model="BillingInfo.CardMonth"
                          :options="month"
                          value-field="m"
                          text-field="m"
                        >
                        </b-form-select>
                        <b-form-select
                          id="CardYear"
                          v-model="BillingInfo.CardYear"
                          :options="year"
                          :state="
                            !$v.BillingInfo.CardYear.$dirty
                              ? null
                              : !$v.BillingInfo.CardYear.required ||
                                $v.BillingInfo.CardYear.$error
                              ? false
                              : null
                          "
                          value-field=""
                          text-field=""
                        >
                        </b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <label for="CardCode">CVV Code:</label>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-credit-card"></i>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          id="CardCode"
                          name="CardCode"
                          :state="
                            !$v.BillingInfo.CardCode.$dirty
                              ? null
                              : !$v.BillingInfo.CardCode.required ||
                                $v.BillingInfo.CardCode.$error
                              ? false
                              : null
                          "
                          autocomplete="CardCode"
                          v-model="BillingInfo.CardCode"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">
                          This is a required field.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row text-right" style="margin: 0px !important">
                      <button
                        type="submit"
                        class="btn btn-primary width-100 m-r-5 btn-xs"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "view_user",
  components: {
    practiceSidebar,
  },
  mixins: [validationMixin],
  data() {
    return {
      isLoading: false,
      pField: "password",
      loginUser: {},
      emailErr: "",
      imagePreviewUrl: "",
      StateOptions: [],
      pages: [
        "SeminarPackingItems",
        "Members",
        "Seminars",
        "Webinar",
        "EmailMarketing",
        "Referrals",
        "Modules",
        "Documents",
        "Videos",
        "Webcontent",
      ],
      month: [
        { m: 1 },
        { m: 2 },
        { m: 3 },
        { m: 4 },
        { m: 5 },
        { m: 6 },
        { m: 7 },
        { m: 8 },
        { m: 9 },
        { m: 10 },
        { m: 11 },
        { m: 12 },
      ],
      year: [],
      allowedPages: [],
      BillingInfo: {
        PracticeName: "",
        FirstName: "",
        CardNumber: "",
        CardMonth: 1,
        CardYear: "",
        LastName: "",
        CardCode: "",
        StateID: "",
        Phone: "",
        City: "",
        Address1: "",
        Address2: "",
        ZipCode: "",
      },
      removeCreditCard: false,
      showCheckbox: true,
      StatusOptions: [{ item: "DC" }, { item: "CA" }],
      PrefixOptions: [
        { item: "Dr." },
        { item: "Mr." },
        { item: "Mrs." },
        { item: "Ms." },
      ],
    };
  },
  validations: {
    BillingInfo: {
      FirstName: {
        required,
      },
      PracticeName: {
        required,
      },
      LastName: {
        required,
      },
      CardCode: {
        required,
      },
      CardNumber: {
        required,
      },
      CardMonth: {
        required,
      },
      CardYear: {
        required,
      },
      StateID: {
        required,
      },
      Phone: {
        required,
      },
      City: {
        required,
      },
      Address1: {
        required,
      },
      ZipCode: {
        required,
      },
    },
  },
  methods: {
    yearGenerate() {
      let cYear = parseInt(moment().format("Y"));
      let yearArr = [];
      for (let i = 0; i < 10; i++) {
        yearArr.push(cYear + i);
      }
      this.year = yearArr;
    },
    getStates() {
      userAPI.getStates(
        (res) => {
          this.StateOptions = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getBillingInfoByUserID() {
      this.isLoading = true;
      userAPI.getBillingInfoByUserID(
        { UserID: this.loginUser.userID },
        (res) => {
          this.BillingInfo = res.data.data;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },
    removeCreditCardHandler() {
      if (this.removeCreditCard) {
        // If the checkbox is checked, clear the related fields
        this.BillingInfo.CardNumber = "";
        this.BillingInfo.CardMonth = null;
        this.BillingInfo.CardYear = null;
        this.BillingInfo.CardCode = "";

        this.showCheckbox = !this.removeCreditCard;
      }
    },
    onInputCreditCard(value) {
      this.removeCreditCard = false;
      this.showCheckbox = value.trim().length > 0;
    },
    showPass() {
      this.pField = this.pField == "password" ? "text" : "password";
    },
    removeImage() {
      this.imagePreviewUrl = "";
      this.BillingInfo.Image = null;
      this.$refs.fileInput.value = "";
    },
    saveUser() {
      this.$v.BillingInfo.$touch();

      if (this.$v.BillingInfo.$anyError) {
        return;
      }

      userAPI.saveBillingInfo(
        { ...this.BillingInfo, UserID: this.loginUser.userID },
        (res) => {
          this.$showNotification(res.data, "success");
        },
        (err) => {
          if (err.response.status == 410) {
            this.emailErr = err.response.data.message.Email[0];
          }
        }
      );
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;

    if (user.Status == "DC" || user.Status == "CA") {
      this.$router.push({ name: "user_dashboard" });
    }
    this.yearGenerate();
    this.getBillingInfoByUserID();
    this.getStates();
  },
};
</script>
<style>
.form-group .input-group {
  flex-wrap: nowrap;
}
</style>